<template>
  <div class="row teach-count">
    <div class="col">
      <div class="row mb-3">
        <div class="col">
          <div class="flex-between flex-align-center">
            <div>
              <el-select
                class="group-condition"
                v-if="filterDimension == 1"
                v-model="group"
                @change="handleGroup"
              >
                <el-option value="0" label="全部小组"></el-option>
                <el-option
                  v-for="item in groupOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
              <el-select
                class="group-condition"
                v-if="filterDimension == 2"
                v-model="course"
                @change="handleCourse"
              >
                <el-option value="0" label="全部选课"></el-option>
                <el-option
                  v-for="item in courseOption"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </div>

            <div class="data-range">统计范围：{{ countArea }}</div>
          </div>
        </div>
      </div>

      <el-row class="rank mb-3" :gutter="20">
        <el-col :lg="12" :xs="24" :sm="24">
          <el-card class="access-rank-card">
            <div class="flex-between">
              <span class="chart-title">课程访问排行</span>
              <el-radio-group
                size="mini"
                v-model="accessRank"
                @change="handlePeriodChange('access')"
              >
                <el-radio-button label="1">近七天</el-radio-button>
                <el-radio-button label="2">近三十天</el-radio-button>
                <el-radio-button label="0">全部数据</el-radio-button>
              </el-radio-group>
            </div>
            <div id="course-access-rank-chart" :style="{ height: '400px' }"></div>
          </el-card>
        </el-col>
        <el-col :lg="12" :xs="24" :sm="24">
          <el-card>
            <div class="flex-between">
              <span class="chart-title">任务完成排行</span>
              <el-radio-group
                size="mini"
                v-model="completeRank"
                @change="handlePeriodChange('activity')"
              >
                <el-radio-button label="1">近七天</el-radio-button>
                <el-radio-button label="2">近三十天</el-radio-button>
                <el-radio-button label="0">全部数据</el-radio-button>
              </el-radio-group>
            </div>
            <div id="work-complete-rank-chart" :style="{ height: '400px' }"></div>
          </el-card>
        </el-col>
      </el-row>
      <el-row class="theme-study mb-3">
        <div class="tag-box">
          <div class="tag-box-inner">
            <span>&nbsp;主题学习</span>
          </div>
          <div class="tag-box-bottom"></div>
        </div>
        <el-card class="theme-study-card" style="position: positive">
          <el-row :gutter="20" class="theme-study-stats flex-wrap">
            <el-col :lg="12" :xs="24" :sm="24">
              <el-row :gutter="20" class="flex-align-center" style="height: 50%">
                <el-col :span="12" class="flex-center-center">
                  <div class="theme-study-item flex-column">
                    <div class="item-content">{{ accessData.last_week.access || 0 }}</div>
                    <div class="item-title">上周主题学习次数</div>
                  </div>
                </el-col>
                <el-col :span="12" class="flex-center-center">
                  <div class="theme-study-item flex-column">
                    <div class="item-content">{{ accessData.this_week.access || 0 }}</div>
                    <div class="item-title">本周主题学习次数</div>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" class="flex-align-center" style="height: 50%">
                <el-col :span="12" class="flex-center">
                  <div class="theme-study-item flex-column">
                    <div class="item-content">
                      {{ accessData.last_week.student_not_view || 0 }}
                    </div>

                    <div class="item-title">上周未访问学生数</div>
                  </div>
                </el-col>
                <el-col :span="12" class="flex-center">
                  <div class="theme-study-item flex-column">
                    <div class="item-content">{{ accessData.this_week.student_not_view || 0 }}</div>
                    <div class="item-title">本周未访问学生数</div>
                  </div>
                </el-col>
              </el-row>
            </el-col>
            <el-col class="theme-study-trend-chart" :lg="12" :xs="24" :sm="24">
              <div id="week-access-trend-chart" :style="{ height: '400px' }"></div>
            </el-col>
          </el-row>
          <el-row class="theme-study-active-chart">
            <div id="day-active-chart" :style="{ height: '400px' }"></div>
          </el-row>
        </el-card>
      </el-row>

      <el-row class="homework chart-plus-table mb-3">
        <el-card>
          <div slot="header" class="flex-between flex-align-center">
            <div class="flex-align-center">
              <i class="mdi mdi-book-open-outline title-icon"></i>
              <span class="card-header-title">作业</span>
            </div>

            <div>
              <el-button type="out-line" size="mini" @click="exportTable('assign', 'assign-table')">
                下载表格
              </el-button>
              <el-button type="out-line" size="mini" @click="homeworkTableVisiable">
                {{ homeWorkTableBtn }}
              </el-button>
            </div>
          </div>
          <el-row class="mb-3" :gutter="20">
            <el-col :span="6">
              <div class="flex-center-center">
                <span class="item-title">作业数</span>
                <span class="item-content">{{ assignData.count }}个</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均提交率</span>
                <span class="item-content">{{ assignData.submit_rate * 100 }}%</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均批改率</span>
                <span class="item-content">{{ assignData.graded_rate * 100 }}%</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均成绩</span>
                <span class="item-content">{{ Number(assignData.score).toFixed(2) || 0 }}分</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="assignData.count !== 0 && assignData.table !== []">
            <el-col :span="12">
              <div class="flex-center-center chart-title">作业提交统计</div>
              <div id="assign-submit-chart" :style="{ height: '400px' }"></div>
            </el-col>
            <el-col :span="12">
              <div class="flex-center-center chart-title">作业成绩统计</div>
              <div id="assign-grade-chart" :style="{ height: '400px' }"></div>
            </el-col>
          </el-row>
          <el-row class="homework-table" v-show="showHomeWorkTable">
            <el-table
              id="assign-table"
              :data="assignData.table"
              row-key="id"
              default-expand-all
              stripe
            >
              <el-table-column prop="title" label="作业名称"></el-table-column>
              <el-table-column prop="type" label="作业类型"></el-table-column>
              <el-table-column prop="start_time" label="开始时间"></el-table-column>
              <el-table-column prop="end_time" label="结束时间"></el-table-column>
              <el-table-column prop="submit" label="已提交"></el-table-column>
              <el-table-column prop="not_submit" label="未提交"></el-table-column>
              <el-table-column prop="review" label="待批改"></el-table-column>
              <el-table-column prop="max_score" label="最高分"></el-table-column>
              <el-table-column prop="min_score" label="最低分"></el-table-column>
              <el-table-column prop="score" label="平均分"></el-table-column>
              <el-table-column width="120" label="操作">
                <template slot-scope="scope">
                  <span>/</span>
                  <!-- <span class="operative" @click="viewHomeworkGrade(scope.row)">查看学生成绩</span> -->
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>
      </el-row>
      <el-row class="test chart-plus-table mb-3">
        <el-card>
          <div slot="header" class="flex-between flex-align-center">
            <div class="flex-align-center">
              <i class="mdi mdi-clipboard-text-outline title-icon"></i>
              <span class="card-header-title">测验</span>
            </div>
            <div>
              <el-button type="out-line" size="mini" @click="exportTable('quiz', 'quiz-table')">
                下载表格
              </el-button>
              <el-button type="out-line" size="mini" @click="testTableVisiable">
                {{ testTableBtn }}
              </el-button>
            </div>
          </div>
          <el-row class="mb-3" :gutter="20">
            <el-col :span="6">
              <div class="flex-center-center">
                <span class="item-title">测验数</span>
                <span class="item-content">{{ quizData.count }}个</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均提交率</span>
                <span class="item-content">{{ quizData.submit_rate * 100 }}%</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均批改率</span>
                <span class="item-content">{{ quizData.graded_rate * 100 }}%</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均成绩</span>
                <span class="item-content">{{ Number(quizData.score).toFixed(2) || 0 }}分</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-show="quizData.count !== 0 && quizData.table !== []">
            <el-col :span="12">
              <div class="flex-center-center chart-title">测验提交统计</div>
              <div id="quiz-submit-chart" :style="{ height: '400px' }"></div>
            </el-col>
            <el-col :span="12">
              <div class="flex-center-center chart-title">测验成绩统计</div>
              <div id="quiz-grade-chart" :style="{ height: '400px' }"></div>
            </el-col>
          </el-row>
          <el-row class="homework-table" v-show="showTestTable">
            <el-table id="quiz-table" :data="quizData.table" row-key="id" default-expand-all stripe>
              <el-table-column prop="title" label="测验名称"></el-table-column>
              <el-table-column prop="question" label="题目数量"></el-table-column>
              <el-table-column prop="attempt_num" label="作答次数"></el-table-column>
              <el-table-column prop="start_time" label="开始时间"></el-table-column>
              <el-table-column prop="end_time" label="结束时间"></el-table-column>
              <el-table-column prop="submit" label="已提交"></el-table-column>
              <el-table-column prop="not_submit" label="未提交"></el-table-column>
              <el-table-column prop="review" label="待批改"></el-table-column>
              <el-table-column prop="score" label="平均分"></el-table-column>
              <el-table-column width="120" label="操作">
                <template slot-scope="scope">
                  <span>/</span>
                  <!-- <span class="operative" @click="viewTestGrade(scope.row)">查看学生成绩</span> -->
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>
      </el-row>
      <el-row class="discuss chart-plus-table mb-3">
        <el-card>
          <div slot="header" class="flex-between flex-align-center">
            <div class="flex-align-center">
              <i class="mdi mdi-comment-text-multiple-outline title-icon"></i>
              <span class="card-header-title">讨论</span>
            </div>
            <div>
              <el-button type="out-line" size="mini" @click="exportTable('forum', 'forum-table')">
                下载表格
              </el-button>
              <el-button type="out-line" size="mini" @click="discussTableVisiable">
                {{ discussTableBtn }}
              </el-button>
            </div>
          </div>
          <el-row class="mb-3" :gutter="20">
            <el-col :span="6">
              <div class="flex-center-center">
                <span class="item-title">讨论区数</span>
                <span class="item-content">{{ forumData.count }}个</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">讨论主题数</span>
                <span class="item-content">{{ forumData.discussion }}个</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">讨论回帖数</span>
                <span class="item-content">{{ forumData.post }}个</span>
              </div>
            </el-col>
            <el-col class="left-border-line" :span="6">
              <div class="flex-center-center">
                <span class="item-title">平均参与率</span>
                <span class="item-content">{{ forumData.participate_rate * 100 }}%</span>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" v-if="forumData.count > 0 && quizData.table !== []">
            <el-col :span="12">
              <div class="flex-center-center chart-title">讨论统计</div>
              <div id="forum-count-chart" :style="{ height: '400px' }"></div>
            </el-col>
            <el-col :span="12">
              <div class="flex-center-center chart-title">讨论提交统计</div>
              <div id="forum-submit-chart" :style="{ height: '400px' }"></div>
            </el-col>
          </el-row>
          <el-row class="homework-table" v-show="showDiscussTable">
            <el-table
              id="forum-table"
              :data="forumData.table"
              row-key="id"
              default-expand-all
              stripe
            >
              <el-table-column prop="title" label="讨论区名称"></el-table-column>
              <el-table-column prop="discussion" label="主题数"></el-table-column>
              <el-table-column prop="post" label="回帖数"></el-table-column>
              <el-table-column prop="start_time" label="开始时间"></el-table-column>
              <el-table-column prop="end_time" label="结束时间"></el-table-column>
              <el-table-column prop="participate" label="参与学生数"></el-table-column>
              <el-table-column prop="not_participate" label="未参与学生数"></el-table-column>
              <el-table-column prop="grade_post" label="获评分的帖子数"></el-table-column>
              <el-table-column prop="score" label="平均分"></el-table-column>
              <el-table-column width="240" label="操作">
                <template slot-scope="scope">
                  <span>/</span>
                  <!-- <span class="operative" @click="viewDiscussGrade(scope.row)">查看学生成绩</span>
                  <span class="operative" @click="viewAllStatistic(scope.row)">总览统计</span> -->
                </template>
              </el-table-column>
            </el-table>
          </el-row>
        </el-card>
      </el-row>

      <el-dialog :title="completeDialogTitle" :visible.sync="completeDialogVisible" width="30%">
        <span>{{ completeDialogContent }}</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="completeDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      weeks: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      hours: [
        '00:00',
        '01:00',
        '02:00',
        '03:00',
        '04:00',
        '05:00',
        '06:00',
        '07:00',
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00',
        '19:00',
        '20:00',
        '21:00',
        '22:00',
        '23:00',
      ], // 排行图表
      courseAccessRankChart: null,
      workCompleteRankChart: null,
      courseAccessRankData: [],
      workCompleteRankData: [],

      // 访问量/活跃数图表
      weekAccessTrendChart: null,
      dayActiveChart: null,
      accessData: { last_week: {}, this_week: {}, day: [], week: [] },

      // 作业图表
      assignSubmitChart: null,
      assignGradeChart: null,
      assignData: { count: 0, table: [] },

      // 测验图表
      quizSubmitChart: null,
      quizGradeChart: null,
      quizData: { count: 0, table: [] },

      // 讨论图表
      forumCountChart: null,
      forumSubmmitChart: null,
      forumData: { count: 0, table: [] },

      screenWidth: '',
      screenHeight: '',
      // 教学统计活动操作
      completeDialogTitle: '提示',
      completeDialogContent: '是否强制完成',
      completeDialogVisible: false,
      // 小组选项
      group: '0',
      groupOption: [],
      // 选课选项
      course: '0',
      courseOption: [],
      // 教学统计
      accessRank: '1',
      completeRank: '1',
      homeWorkTableBtn: '显示表格',
      testTableBtn: '显示表格',
      discussTableBtn: '显示表格',
      showHomeWorkTable: false,
      showTestTable: false,
      showDiscussTable: false,
    }
  },
  watch: {
    screenWidth() {
      this.getReSize()
    },
  },
  computed: {
    // 统计范围
    countArea() {
      return (
        this.$store.state.course.courseInfo.statistics_start_time.split('-').join('.') +
        '-' +
        this.$store.state.course.courseInfo.statistics_end_time.split('-').join('.')
      )
    },
    // 筛选维度
    filterDimension() {
      return this.$store.state.course.courseInfo.search_setting
    },
    // 课程访问排行图表数据
    accessRankData() {
      let data = {}
      let x = []
      let y = []
      for (let i of this.courseAccessRankData) {
        x.push(i.firstname)
        y.push(i.data)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    // 任务完成排行图表数据
    completeRankData() {
      let data = {}
      let x = []
      let y = []
      for (let i of this.workCompleteRankData) {
        x.push(i.firstname)
        y.push(i.data)
      }
      data['x'] = x
      data['y'] = y
      return data
    },
    // 24小时学生活跃数图表数据
    dayData() {
      let data = {}
      let x = []
      let lastWeek = []
      let curWeek = []
      for (let i of this.accessData.day) {
        x.push(this.hours[i.hour])
        lastWeek.push(i.last)
        curWeek.push(i['this'])
      }
      data['x'] = x
      data['lastWeek'] = lastWeek
      data['curWeek'] = curWeek
      console.log('dayData', data)

      return data
    },
    // 周访问量趋势图表数据
    weekData() {
      let data = {}
      let x = []
      let lastWeek = []
      let curWeek = []
      for (let i of this.accessData.week) {
        x.push(this.weeks[i.day - 1])
        lastWeek.push(i.last)
        curWeek.push(i['this'])
      }
      data['x'] = x
      data['lastWeek'] = lastWeek
      data['curWeek'] = curWeek
      console.log('weekdata', data)
      return data
    },
    // 作业统计图表数据
    assignChartData() {
      let data = {},
        x = [],
        submit = [],
        notSubmit = [],
        review = [],
        maxScore = [],
        avgScore = [],
        minScore = []
      for (let i of this.assignData.table) {
        x.push(i.title)
        submit.push(i.submit)
        notSubmit.push(i.not_submit)
        review.push(i.review)
        maxScore.push(i.max_score)
        avgScore.push(i.score)
        minScore.push(i.min_score)
      }
      data['x'] = x
      data['submit'] = submit
      data['notSubmit'] = notSubmit
      data['review'] = review
      data['maxScore'] = maxScore
      data['avgScore'] = avgScore
      data['minScore'] = minScore
      console.log('assignChartData', data)
      return data
    },
    // 测验统计图表数据
    quizChartData() {
      let data = {},
        x = [],
        submit = [],
        notSubmit = [],
        review = [],
        maxScore = [],
        avgScore = [],
        minScore = []
      for (let i of this.quizData.table) {
        x.push(i.title)
        submit.push(i.submit)
        notSubmit.push(i.not_submit)
        review.push(i.review)
        maxScore.push(i.max_score)
        avgScore.push(i.score)
        minScore.push(i.min_score)
      }
      data['x'] = x
      data['submit'] = submit
      data['notSubmit'] = notSubmit
      data['review'] = review
      data['maxScore'] = maxScore
      data['avgScore'] = avgScore
      data['minScore'] = minScore
      console.log('quizChartData', data)
      return data
    },
    // 讨论统计图表数据
    forumChartData() {
      let data = {},
        x = [],
        participate = [],
        notParticipate = [],
        discussion = [],
        post = []
      for (let i of this.forumData.table) {
        x.push(i.title)
        participate.push(i.participate)
        notParticipate.push(i.not_participate)
        discussion.push(i.discussion)
        post.push(i.post)
      }
      data['x'] = x
      data['participate'] = participate
      data['notParticipate'] = notParticipate
      data['discussion'] = discussion
      data['post'] = post
      console.log('forumChartData', data)
      return data
    },
  },
  mounted() {
    this.getCourseSituationRankApi('access')
    this.getCourseSituationRankApi('activity')
    this.getSituationChartApi()
    this.getCourseGroupApi()
    this.getCourseJoinTypeApi()
    // this.initCompleteRankchart()
    this.screenWidth = document.body.clientWidth //监听页面缩放
    this.screenHeight = document.body.clientHeight
    window.onresize = () => {
      return (() => {
        this.screenWidth = document.body.clientWidth
        this.screenHeight = document.body.clientHeight
      })()
    }
  },
  methods: {
    // 获取课程小组
    async getCourseGroupApi() {
      await this.$store
        .dispatch('course/getCourseGroup', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.groupOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取选课方式
    async getCourseJoinTypeApi() {
      await this.$store
        .dispatch('course/getCourseJoinType', {
          course_id: +this.$route.query.courseId,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.courseOption = res.data
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取排行数据
    async getCourseSituationRankApi(type) {
      let time = type === 'access' ? this.accessRank : this.completeRank
      await this.$store
        .dispatch('course/getCourseSituationRank', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course || 0,
          time: time,
          type: type,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            // 初始化排行图表
            if (type === 'access') {
              this.courseAccessRankData = res.data
              this.iniCourseAccessRankChart(this.accessRankData)
            } else if (type === 'activity') {
              this.workCompleteRankData = res.data
              this.iniWorkCompleteRankChart(this.completeRankData)
            }
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 获取图表数据
    async getSituationChartApi() {
      await this.$store
        .dispatch('course/getSituationChart', {
          course_id: Number(this.$route.query.courseId),
          group: +this.group || 0,
          method: +this.course || 0,
        })
        .then(res => {
          console.log('res:', res)
          if (res.code === 1) {
            this.accessData = res.data.access
            this.assignData = res.data.assign
            this.quizData = res.data.quiz
            this.forumData = res.data.forum
            // 初始化图表
            this.iniWeekAccessTrendChart(this.weekData)
            this.iniDayActiveChart(this.dayData)
            if (this.assignData.count !== 0) {
              this.$nextTick(function () {
                this.iniAssignSubmitChart(this.assignChartData)
                this.iniAssignGradeChart(this.assignChartData)
              })
            }
            if (this.quizData.count !== 0) {
              this.$nextTick(function () {
                this.iniQuizSubmitChart(this.quizChartData)
                this.iniQuizGradeChart(this.quizChartData)
              })
            }
            if (this.forumData.count !== 0) {
              this.$nextTick(function () {
                this.iniForumCountChart(this.forumChartData)
                this.iniForumSubmitChart(this.forumChartData)
              })
            }
          }
        })
        .catch(err => {
          console.log('err:', err)
        })
    },
    // 课程访问排行图表
    iniCourseAccessRankChart(data) {
      let chart = this.$echarts.init(document.getElementById('course-access-rank-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: Math.floor(data.x.length / 10),
          },
        },
        yAxis: {
          type: 'value',
          name: '访问数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [10, 50, 20, 0],
            fontSize: '12',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#3283F6',
            },
          },
        ],
      }
      chart.setOption(option)
      this.courseAccessRankChart = chart
    },
    // 任务完成排行图表
    iniWorkCompleteRankChart(data) {
      let chart = this.$echarts.init(document.getElementById('work-complete-rank-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        xAxis: {
          type: 'category',
          data: data.x,
          axisLabel: {
            interval: Math.floor(data.x.length / 10),
          },
        },
        yAxis: {
          type: 'value',
          name: '任务数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [10, 50, 20, 0],
            fontSize: '12',
            align: 'center',
          },
        },
        series: [
          {
            data: data.y,
            type: 'bar',
            itemStyle: {
              color: '#44CF9C',
            },
          },
        ],
      }
      chart.setOption(option)
      this.workCompleteRankChart = chart
    },
    // 周访问量趋势图表
    iniWeekAccessTrendChart(data) {
      let chart = this.$echarts.init(document.getElementById('week-access-trend-chart'))
      let option = {
        title: {
          text: '周访问量趋势',
          textStyle: {
            color: '#6C757D',
            fontSize: 16,
          },
        },
        grid: {
          left: 40,
          right: 10,
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['上周', '本周'],
          top: 25,
          right: 0,
        },
        xAxis: {
          type: 'category',
          data: data.x,
        },
        yAxis: {
          type: 'value',
          name: '人数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [0, 40, 0, 0],
            fontSize: 12,
            align: 'center',
          },
        },
        series: [
          {
            name: '上周',
            data: data.lastWeek,
            type: 'line',
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '本周',
            data: data.curWeek,
            type: 'line',
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.weekAccessTrendChart = chart
    },
    // 24小时学生活跃数图表
    iniDayActiveChart(data) {
      let chart = this.$echarts.init(document.getElementById('day-active-chart'))
      let option = {
        title: {
          text: '24小时学生活跃数',
          textStyle: {
            color: '#6C757D',
            fontSize: 16,
          },
        },
        grid: {
          left: 40,
          right: 10,
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          data: ['昨日', '今日'],
          top: 25,
          right: 0,
        },
        xAxis: {
          type: 'category',
          data: data.x,
          show: true,
          axisLabel: {
            interval: 0,
          },
        },
        yAxis: {
          type: 'value',
          name: '人数',
          minInterval: 1,
          nameTextStyle: {
            color: '#98a6ad',
            padding: [0, 40, 0, 0],
            fontSize: 12,
            align: 'center',
          },
        },
        series: [
          {
            name: '昨日',
            data: data.lastWeek,
            type: 'line',
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '今日',
            data: data.curWeek,
            type: 'line',
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.dayActiveChart = chart
    },
    // 作业提交统计图表
    iniAssignSubmitChart(data) {
      let chart = this.$echarts.init(document.getElementById('assign-submit-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.x,
            axisLabel: {
              interval: Math.floor(data.x.length / 10),
              rotate: 30, //x轴文字倾斜
              padding: [0, -30, 0, 30], //文字左右定位
              margin: [35],
              formatter: function (value) {
                let rowMAx = 10
                let overValue = ''
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += '\n'
                    overValue += value[i]
                  } else {
                    overValue += value[i]
                  }
                }
                return overValue
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '作业数',
            minInterval: 1,
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 10, 40],
              fontSize: 12,
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '已提交',
            type: 'bar',
            stack: 'Ad',
            data: data.submit,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '未提交',
            type: 'bar',
            stack: 'Ad',
            data: data.notSubmit,
            itemStyle: {
              color: '#6CB3F9',
            },
            barGap: 0,
          },

          {
            name: '待批阅',
            type: 'bar',
            data: data.review,
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.assignSubmitChart = chart
    },
    // 作业成绩统计图表
    iniAssignGradeChart(data) {
      let chart = this.$echarts.init(document.getElementById('assign-grade-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.x,
            axisLabel: {
              interval: Math.floor(data.x.length / 10),
              rotate: 30, //x轴文字倾斜
              padding: [0, -30, 0, 30], //文字左右定位
              margin: [35],
              formatter: function (value) {
                let rowMAx = 10
                let overValue = ''
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += '\n'
                    overValue += value[i]
                  } else {
                    overValue += value[i]
                  }
                }
                return overValue
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '分数',
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 10, 30],
              fontSize: 12,
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '最高分',
            type: 'bar',
            data: data.maxScore,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '平均分',
            type: 'bar',
            data: data.avgScore,
            itemStyle: {
              color: '#44CF9C',
            },
          },

          {
            name: '最低分',
            type: 'bar',
            data: data.minScore,
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.assignGradeChart = chart
    },
    // 测验提交统计图表
    iniQuizSubmitChart(data) {
      let chart = this.$echarts.init(document.getElementById('quiz-submit-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.x,
            axisLabel: {
              interval: Math.floor(data.x.length / 10),
              rotate: 30, //x轴文字倾斜
              padding: [0, -30, 0, 30], //文字左右定位
              margin: [35],
              formatter: function (value) {
                let rowMAx = 10
                let overValue = ''
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += '\n'
                    overValue += value[i]
                  } else {
                    overValue += value[i]
                  }
                }
                return overValue
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '测验数',
            minInterval: 1,
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 10, 40],
              fontSize: 12,
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '已提交',
            type: 'bar',
            stack: 'Ad',
            data: data.submit,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '未提交',
            type: 'bar',
            stack: 'Ad',
            data: data.notSubmit,
            itemStyle: {
              color: '#6CB3F9',
            },
            barGap: 0,
          },

          {
            name: '待批阅',
            type: 'bar',
            data: data.review,
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.quizSubmitChart = chart
    },
    // 测验成绩统计图表
    iniQuizGradeChart(data) {
      let chart = this.$echarts.init(document.getElementById('quiz-grade-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.x,
            axisLabel: {
              interval: Math.floor(data.x.length / 10),
              rotate: 30, //x轴文字倾斜
              padding: [0, -30, 0, 30], //文字左右定位
              margin: [35],
              formatter: function (value) {
                let rowMAx = 10
                let overValue = ''
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += '\n'
                    overValue += value[i]
                  } else {
                    overValue += value[i]
                  }
                }
                return overValue
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '分数',
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 10, 30],
              fontSize: 12,
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '最高分',
            type: 'bar',
            data: data.maxScore,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '平均分',
            type: 'bar',
            data: data.avgScore,
            itemStyle: {
              color: '#44CF9C',
            },
          },

          {
            name: '最低分',
            type: 'bar',
            data: data.minScore,
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.quizGradeChart = chart
    },
    // 讨论统计图表
    iniForumCountChart(data) {
      let chart = this.$echarts.init(document.getElementById('forum-count-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.x,
            axisLabel: {
              interval: Math.floor(data.x.length / 10),
              rotate: 30, //x轴文字倾斜
              padding: [0, -30, 0, 30], //文字左右定位
              margin: [35],
              formatter: function (value) {
                let rowMAx = 10
                let overValue = ''
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += '\n'
                    overValue += value[i]
                  } else {
                    overValue += value[i]
                  }
                }
                return overValue
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '测验数',
            minInterval: 1,
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 10, 40],
              fontSize: 12,
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '主题数',
            type: 'bar',
            data: data.discussion,
            barGap: 0,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '回帖数',
            type: 'bar',
            data: data.post,
            itemStyle: {
              color: '#44CF9C',
            },
          },
        ],
      }
      chart.setOption(option)
      this.forumCountChart = chart
    },
    // 讨论提交统计图表
    iniForumSubmitChart(data) {
      let chart = this.$echarts.init(document.getElementById('forum-submit-chart'))
      let option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
          },
        },
        legend: {},
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
        },
        xAxis: [
          {
            type: 'category',
            data: data.x,
            axisLabel: {
              interval: Math.floor(data.x.length / 10),
              rotate: 30, //x轴文字倾斜
              padding: [0, -30, 0, 30], //文字左右定位
              margin: [35],
              formatter: function (value) {
                let rowMAx = 10
                let overValue = ''
                for (let i = 0; i < value.length; i++) {
                  if (i % rowMAx == 0 && i != 0) {
                    overValue += '\n'
                    overValue += value[i]
                  } else {
                    overValue += value[i]
                  }
                }
                return overValue
              },
            },
          },
        ],
        yAxis: [
          {
            type: 'value',
            name: '分数',
            nameTextStyle: {
              color: '#98a6ad',
              padding: [0, 50, 10, 30],
              fontSize: 12,
              align: 'center',
            },
          },
        ],
        series: [
          {
            name: '已提交',
            type: 'bar',
            stack: 'forum',
            data: data.participate,
            itemStyle: {
              color: '#3283F6',
            },
          },
          {
            name: '未提交',
            type: 'bar',
            stack: 'forum',
            data: data.notParticipate,
            itemStyle: {
              color: '#F86262',
            },
          },
        ],
      }
      chart.setOption(option)
      this.forumSubmmitChart = chart
    },
    // 图表宽度跟随页面宽度变化
    getReSize() {
      let chartArr = [
        this.courseAccessRankChart,
        this.workCompleteRankChart,
        this.weekAccessTrendChart,
        this.dayActiveChart,
        this.assignSubmitChart,
        this.assignGradeChart,
      ]
      for (let i = 0; i < chartArr.length; i++) {
        //此处定时器是为了在页面存在多个图时，resize方法的调用时间微微错开，避免明显的卡顿
        setTimeout(function () {
          if (chartArr[i]) {
            chartArr[i].resize()
          }
        }, 200)
      }
    },
    // 隐藏/显示表格
    homeworkTableVisiable() {
      this.showHomeWorkTable = !this.showHomeWorkTable
      if (this.showHomeWorkTable) {
        this.homeWorkTableBtn = '隐藏表格'
      } else this.homeWorkTableBtn = '显示表格'
    },
    testTableVisiable() {
      this.showTestTable = !this.showTestTable
      if (this.showTestTable) {
        this.testTableBtn = '隐藏表格'
      } else this.testTableBtn = '显示表格'
    },
    discussTableVisiable() {
      this.showDiscussTable = !this.showDiscussTable
      if (this.showDiscussTable) {
        this.discussTableBtn = '隐藏表格'
      } else this.discussTableBtn = '显示表格'
    },
    viewHomeGrade(val) {
      console.log('homework', val)
    },
    // 测验查看学生成绩
    viewTestGrade(val) {
      console.log('test', val)
    },
    // 讨论查看学生成绩
    viewDiscussGrade(val) {
      console.log('discuss', val)
    },
    // 讨论总览统计
    viewAllStatistic(val) {
      console.log('discuss statistic', val)
    },
    // 任务完成排行切换周期
    handlePeriodChange(type) {
      this.getCourseSituationRankApi(type)
    },
    // 课程小组筛选事件
    handleGroup(value) {
      console.log('value:', value)
      this.getCourseSituationRankApi('access')
      this.getCourseSituationRankApi('activity')
      this.getSituationChartApi()
    },
    // 选课方式筛选事件
    handleCourse(value) {
      console.log('value:', value)
      this.getCourseSituationRankApi('access')
      this.getCourseSituationRankApi('activity')
      this.getSituationChartApi()
    },
    // 导出表格
    exportTable(type, tableId) {
      //导出名称
      let typeName = '作业'
      switch (type) {
        case 'assign':
          break
        case 'quiz':
          typeName = '测验'
          break
        case 'forum':
          typeName = '讨论'
          break
      }
      let excelName = typeName + '统计' + new Date().getTime() + '.xlsx'
      const xlsxParam = { raw: true } //转化成Excel使用原始格式
      const table_book = this.$XLSX.utils.table_to_book(
        document.querySelector('#' + tableId),
        xlsxParam
      )
      const table_write = this.$XLSX.write(table_book, {
        bookType: 'xlsx',
        bookSST: true,
        type: 'array',
      })
      try {
        this.$FileSaver.saveAs(
          new Blob([table_write], { type: 'application/octet-stream' }),
          excelName
        )
      } catch (e) {
        if (typeof console !== 'undefined') console.log(e, table_write)
      }
      return table_write
    },
  },
}
</script>
<style lang="scss" scoped>
.teach-count {
  ::v-deep .el-table {
    thead {
      th.el-table__cell {
        background-color: #f5f7fa;
      }
    }
    .cell {
      color: #6c757d;
    }
    .el-card {
      .el-card_header {
        background-color: rgba(243, 247, 249, 1);
      }
    }
  }
  .group-condition {
    margin-right: 1rem;
  }
  .data-range {
    font-size: 14px;
    color: #6c757d;
    line-height: 19px;
  }
  .tag-img {
    position: absolute;
    left: 0;
    z-index: 10;
  }
  .rank {
    .chart-title {
      font-size: 16px;
      font-weight: bold;
      color: #343a40;
      line-height: 16px;
    }
  }
  .title-icon {
    margin-right: 8px;
  }
  .title-icon::before {
    font-size: 23px;
  }
  .theme-study {
    .theme-study-card {
      background-color: rgb(248, 250, 252);
    }
    .theme-study-item {
      text-align: center;
      height: 50%;
      .item-content {
        font-size: 32px;
        font-weight: bold;
        color: #343a40;
      }
      .item-title {
        font-size: 14px;
        color: #98a6ad;
      }
    }
  }

  .chart-plus-table {
    .card-header-title {
      font-size: 16px;
      font-weight: bold;
      color: #343a40;
      line-height: 16px;
    }
    .left-border-line {
      border-left: 1px solid rgba(229, 232, 235, 1);
    }
    .item-title {
      font-size: 14px;
      color: #98a6ad;
    }
    .item-content {
      margin-left: 11px;
      font-size: 32px;
      font-weight: bold;
      color: #343a40;
    }
    .chart-title {
      font-size: 16px;
      font-weight: bold;
      color: #6c757d;
    }
    .chart-y {
      padding-left: 10px;
      color: #98a6ad;
    }
  }
  ::v-deep {
    .homework,
    .test,
    .discuss {
      .el-card {
        .el-card__header {
          background: #f3f7f9;
        }
      }
    }
  }
  .tag-box {
    position: relative;

    .tag-box-inner {
      width: 110px;
      height: 31px;
      line-height: 31px;
      font-size: 14px;
      font-weight: bold;
      text-align: center;
      position: absolute;
      white-space: nowrap;
      border-radius: 0px 4px 4px 0px;
      background-color: rgba(50, 131, 246, 1);
      color: white;
      left: -5px;
      top: 24px;
    }
    .tag-box-bottom {
      position: absolute;
      width: 0;
      height: 0;
      border-bottom: 4px solid rgba(9, 102, 195, 1);
      border-right: 4px solid transparent;
      border-left: 4px solid transparent;
      transform: rotate(45deg);
      left: -4.6px;
      top: 54.4px;
    }
  }
  @media screen and (max-width: 1200px) {
    .access-rank-card {
      margin-bottom: 24px;
    }
    .theme-study-stats {
      margin-top: 55px;
    }
    .theme-study-trend-chart {
      margin-top: 24px;
    }
    .theme-study-active-chart {
      margin-top: 24px;
    }
  }
}
</style>
